import { useTranslation } from "react-i18next";
import { X } from "lucide-react";
import type { Row } from "../../config/types";
import StyledSelect from "./StyledSelect";

export default function ManagedDepartments({ departments, value, onChange }: {
  departments: Row[];
  value: string[];
  onChange: (ids: string[]) => void;
}) {
  const { t, i18n } = useTranslation();
  const name = (id: string) => {
    const department = departments.find(item => item.id === id);
    return String((i18n.resolvedLanguage === "fr" ? department?.nameFr : department?.nameEn || department?.name) || t("Unavailable department"));
  };
  const options = departments.filter(item => !value.includes(item.id)).map(item => ({ value: item.id, label: name(item.id) }));
  return <fieldset className="participant-selector span-two">
    <legend>{t("Managed departments")}</legend>
    <p>{t("Choose the departments this employee is responsible for. Leave empty if none.")}</p>
    <StyledSelect
      label={t("Add a managed department")}
      value=""
      options={options}
      searchable
      searchPlaceholder={t("Search departments")}
      emptyMessage={t("No matching departments")}
      placeholder={t(options.length ? "Select a department" : "No departments available")}
      disabled={!options.length}
      onChange={id => { if (!value.includes(id)) onChange([...value, id]); }}
    />
    <ul className="participant-chips" aria-label={t("Managed departments")}>
      {value.map(id => <li key={id} className="participant-chip">
        <span>{name(id)}</span>
        <button type="button" aria-label={t("Remove {{name}}", { name: name(id) })} onClick={() => onChange(value.filter(selected => selected !== id))}><X size={14} /></button>
      </li>)}
    </ul>
    <small>{t("{{count}} selected", { count: value.length })}</small>
  </fieldset>;
}
